export default (theme) => ({
  settingsMenu: {
    overflow: 'hidden',
    boxSizing: 'border-box',
    width: 540,
    backgroundColor: '#ffffff',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 33,
    [theme.breakpoints.down('xl')]: {
      width: 420,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  settingsMenuWrapper: {
    padding: '80px 70px 60px 60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflowY: 'auto',
    height: '100%',
    [theme.breakpoints.down('xl')]: {
      padding: '65px 55px 40px 50px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '45px 25px 30px 25px',
    },
  },
  logoutButton: {
    width: 'max-content',
  },
  logoutIcon: {
    fill: theme.palette.error.main,
    width: 17,
    height: 17,
  },
  logoutButtonText: {
    fontSize: 24,
    marginLeft: 10,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    [theme.breakpoints.down('xl')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  userWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  personIcon: {
    minWidth: 130,
    minHeight: 130,
    width: 130,
    height: 130,
    [theme.breakpoints.down('xl')]: {
      minWidth: 100,
      minHeight: 100,
      width: 100,
      height: 100,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 130,
      minHeight: 130,
      width: 130,
      height: 130,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 90,
      minHeight: 90,
      width: 90,
      height: 90,
    },
  },
  userNameWrapper: {
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
  userName: {
    lineHeight: 1,
    fontWeight: 'bold',
    fontSize: 47,
    marginLeft: 40,
    wordWrap: 'break-word',
    [theme.breakpoints.down('xl')]: {
      fontSize: 36,
      marginLeft: 20,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 47,
      marginLeft: 40,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
      marginLeft: 20,
    },
  },
  userLastName: {
    lineHeight: 1,
    fontWeight: 'bold',
    fontSize: 47,
    marginLeft: 40,
    wordWrap: 'break-word',
    [theme.breakpoints.down('xl')]: {
      fontSize: 36,
      marginLeft: 20,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 47,
      marginLeft: 40,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
      margin: '10px 0 0 20px',
    },
  },
});
